// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_qpg","cls2":"FeedbackModal-cls2_Y_V FeedbackModal-cls1_qpg"};